module.exports = __webpack_public_path__ + "img/2DA-COCCION.445312a3.png";